import { render } from "./allcourse.vue?vue&type=template&id=4fa3833e&scoped=true&ts=true"
import script from "./allcourse.vue?vue&type=script&lang=ts"
export * from "./allcourse.vue?vue&type=script&lang=ts"

import "./allcourse.vue?vue&type=style&index=0&id=4fa3833e&lang=less"
import "./allcourse.vue?vue&type=style&index=1&id=4fa3833e&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa3833e"]])

export default __exports__